import {
	SET_ERROR,
	CORE_AUTH_VERIFY_SUCCESS,
	CORE_AUTH_VERIFY_FAILURE,


	CORE_LOAD_DRAWING_INFORMATION_SUCCESS,
	CORE_LOAD_DRAWING_INFORMATION_FAILURE,

	CORE_SEARCH_DRAWING_REQUEST,
	CORE_SEARCH_DRAWING_SUCCESS,
	CORE_SEARCH_DRAWING_FAILURE,

	CORE_LOAD_ITEM_INFORMATION_SUCCESS,
	CORE_LOAD_ITEM_INFORMATION_FAILURE,



	CORE_SAVE_ITEM_REQUEST,
	CORE_SAVE_ITEM_SUCCESS,
	CORE_SAVE_ITEM_FAILURE,

	CORE_SUBMIT_ITEM_REQUEST,
	CORE_SUBMIT_ITEM_SUCCESS,
	CORE_SUBMIT_ITEM_FAILURE,

	CORE_GEN_CODE_ITEM_REQUEST,
	CORE_GEN_CODE_ITEM_SUCCESS,
	CORE_GEN_CODE_ITEM_FAILURE,

	CORE_RE_SEND_ITEM_REQUEST,
	CORE_RE_SEND_ITEM_SUCCESS,
	CORE_RE_SEND_ITEM_FAILURE,

	CORE_APPROVE_ITEM_REQUEST,
	CORE_APPROVE_ITEM_SUCCESS,
	CORE_APPROVE_ITEM_FAILURE,

	CORE_UPDATE_DRAWING_INFO_REQUEST,
	CORE_UPDATE_DRAWING_INFO_SUCCESS,
	CORE_UPDATE_DRAWING_INFO_FAILURE,

	CORE_CREATE_DRAWING_INFO_REQUEST,
	CORE_CREATE_DRAWING_INFO_SUCCESS,
	CORE_CREATE_DRAWING_INFO_FAILURE,

	CORE_CREATE_DRAWING_REQUEST,
	CORE_CREATE_DRAWING_SUCCESS,
	CORE_CREATE_DRAWING_FAILURE,

	CORE_GET_TUBE_INSIDE_DATA_REQUEST,
	CORE_GET_TUBE_INSIDE_DATA_SUCCESS,
	CORE_GET_TUBE_INSIDE_DATA_FAILURE,

	CORE_GET_PIPE_TYPE_DATA_REQUEST,
	CORE_GET_PIPE_TYPE_DATA_SUCCESS,
	CORE_GET_PIPE_TYPE_DATA_FAILURE,

	CORE_LOAD_CUSTOMER_REQUEST,
	CORE_LOAD_CUSTOMER_SUCCESS,
	CORE_LOAD_CUSTOMER_FAILURE,

	CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST,
	CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS,
	CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE,

	CORE_CREATE_SELL_ORDER_INFO_REQUEST,
	CORE_CREATE_SELL_ORDER_INFO_SUCCESS,
	CORE_CREATE_SELL_ORDER_INFO_FAILURE,

	CORE_UPDATE_SELL_ORDER_INFO_REQUEST,
	CORE_UPDATE_SELL_ORDER_INFO_SUCCESS,
	CORE_UPDATE_SELL_ORDER_INFO_FAILURE,

	CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST,
	CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS,
	CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE,

	CORE_SEARCH_SELL_ORDER_REQUEST,
	CORE_SEARCH_SELL_ORDER_SUCCESS,
	CORE_SEARCH_SELL_ORDER_FAILURE,

	CORE_LOAD_SETTING_REQUEST,
	CORE_LOAD_SETTING_SUCCESS,
	CORE_LOAD_SETTING_FAILURE,

	CORE_CHANGE_SETTING_REQUEST,
	CORE_CHANGE_SETTING_SUCCESS,
	CORE_CHANGE_SETTING_FAILURE,

	CORE_REJECT_SELL_ORDER_REQUEST,
	CORE_REJECT_SELL_ORDER_SUCCESS,
	CORE_REJECT_SELL_ORDER_FAILURE,

	CORE_DELETE_SELL_ORDER_REQUEST,
	CORE_DELETE_SELL_ORDER_SUCCESS,
	CORE_DELETE_SELL_ORDER_FAILURE,

	CORE_PRE_APPROVE_REQUEST,
	CORE_PRE_APPROVE_SUCCESS,
	CORE_PRE_APPROVE_FAILURE,

	CORE_CUSTOMER_APPROVE_REQUEST,
	CORE_CUSTOMER_APPROVE_SUCCESS,
	CORE_CUSTOMER_APPROVE_FAILURE,

	CORE_APPROVE_REQUEST,
	CORE_APPROVE_SUCCESS,
	CORE_APPROVE_FAILURE,

	CORE_SUBMIT_REQUEST,
	CORE_SUBMIT_SUCCESS,
	CORE_SUBMIT_FAILURE,

	CORE_CHANGE_USER_NPI_PERMIT_REQUEST,
	CORE_CHANGE_USER_NPI_PERMIT_SUCCESS,
	CORE_CHANGE_USER_NPI_PERMIT_FAILURE,

	CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST,
	CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS,
	CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE,

	CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST,
	CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS,
	CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE,

	CORE_COMPLETE_SELL_ORDER_REQUEST,
	CORE_COMPLETE_SELL_ORDER_SUCCESS,
	CORE_COMPLETE_SELL_ORDER_FAILURE,

	CORE_COMMENT_SELL_ORDER_REQUEST,
	CORE_COMMENT_SELL_ORDER_SUCCESS,
	CORE_COMMENT_SELL_ORDER_FAILURE,

	CORE_ATTACH_FILE_SELL_ORDER_REQUEST,
	CORE_ATTACH_FILE_SELL_ORDER_SUCCESS,
	CORE_ATTACH_FILE_SELL_ORDER_FAILURE,

	CORE_CREATE_CUSTOMER_REQUEST,
	CORE_CREATE_CUSTOMER_SUCCESS,
	CORE_CREATE_CUSTOMER_FAILURE,

	CORE_GENCODE_NPI_SELL_ORDER_REQUEST,
	CORE_GENCODE_NPI_SELL_ORDER_SUCCESS,
	CORE_GENCODE_NPI_SELL_ORDER_FAILURE,

	CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST,
	CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS,
	CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE,

	CORE_SHOP_APPROVE_SELL_ORDER_REQUEST,
	CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS,
	CORE_SHOP_APPROVE_SELL_ORDER_FAILURE,

	CORE_CANCEL_SELL_ORDER_REQUEST,
	CORE_CANCEL_SELL_ORDER_SUCCESS,
	CORE_CANCEL_SELL_ORDER_FAILURE,

	CORE_ATTACH_FILE_REQ_TUBE_REQUEST,
	CORE_ATTACH_FILE_REQ_TUBE_SUCCESS,
	CORE_ATTACH_FILE_REQ_TUBE_FAILURE,

	//---------------//
	CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST,
	CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS,
	CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE,

	CORE_CREATE_REQ_TUBE_INFO_REQUEST,
	CORE_CREATE_REQ_TUBE_INFO_SUCCESS,
	CORE_CREATE_REQ_TUBE_INFO_FAILURE,

	CORE_UPDATE_REQ_TUBE_INFO_REQUEST,
	CORE_UPDATE_REQ_TUBE_INFO_SUCCESS,
	CORE_UPDATE_REQ_TUBE_INFO_FAILURE,

	CORE_APPROVE_REQ_TUBE_REQUEST,
	CORE_APPROVE_REQ_TUBE_SUCCESS,
	CORE_APPROVE_REQ_TUBE_FAILURE,

	CORE_PRE_APPROVE_REQ_TUBE_REQUEST,
	CORE_PRE_APPROVE_REQ_TUBE_SUCCESS,
	CORE_PRE_APPROVE_REQ_TUBE_FAILURE,

	CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST,
	CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS,
	CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE,

	CORE_REJECT_REQ_TUBE_REQUEST,
	CORE_REJECT_REQ_TUBE_SUCCESS,
	CORE_REJECT_REQ_TUBE_FAILURE,

	CORE_DELETE_REQ_TUBE_REQUEST,
	CORE_DELETE_REQ_TUBE_SUCCESS,
	CORE_DELETE_REQ_TUBE_FAILURE,

	CORE_SUBMIT_REQ_TUBE_REQUEST,
	CORE_SUBMIT_REQ_TUBE_SUCCESS,
	CORE_SUBMIT_REQ_TUBE_FAILURE,

	CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST,
	CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS,
	CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE,

	CORE_COMPLETE_REQ_TUBE_REQUEST,
	CORE_COMPLETE_REQ_TUBE_SUCCESS,
	CORE_COMPLETE_REQ_TUBE_FAILURE,

	CORE_COMMENT_REQ_TUBE_REQUEST,
	CORE_COMMENT_REQ_TUBE_SUCCESS,
	CORE_COMMENT_REQ_TUBE_FAILURE,

	CORE_GENCODE_NPI_REQ_TUBE_REQUEST,
	CORE_GENCODE_NPI_REQ_TUBE_SUCCESS,
	CORE_GENCODE_NPI_REQ_TUBE_FAILURE,

	CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST,
	CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS,
	CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE,

	CORE_SHOP_APPROVE_REQ_TUBE_REQUEST,
	CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS,
	CORE_SHOP_APPROVE_REQ_TUBE_FAILURE,

	CORE_CANCEL_REQ_TUBE_REQUEST,
	CORE_CANCEL_REQ_TUBE_SUCCESS,
	CORE_CANCEL_REQ_TUBE_FAILURE,

	CORE_RE_STATUS_REQ_TUBE_REQUEST,
	CORE_RE_STATUS_REQ_TUBE_SUCCESS,
	CORE_RE_STATUS_REQ_TUBE_FAILURE,

	CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST,
	CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS,
	CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE,

	// ACC ///

	CORE_SEARCH_REQ_ACC_REQUEST,
	CORE_SEARCH_REQ_ACC_SUCCESS,
	CORE_SEARCH_REQ_ACC_FAILURE,

	CORE_SEARCH_REQ_TUBE_REQUEST,
	CORE_SEARCH_REQ_TUBE_SUCCESS,
	CORE_SEARCH_REQ_TUBE_FAILURE,


	CORE_CREATE_REQ_ACC_INFO_SUCCESS,
	CORE_CREATE_REQ_ACC_INFO_FAILURE,

	CORE_UPDATE_REQ_ACC_INFO_SUCCESS,
	CORE_UPDATE_REQ_ACC_INFO_FAILURE,


	CORE_APPROVE_REQ_ACC_REQUEST,
	CORE_APPROVE_REQ_ACC_SUCCESS,
	CORE_APPROVE_REQ_ACC_FAILURE,

	CORE_PRE_APPROVE_REQ_ACC_REQUEST,
	CORE_PRE_APPROVE_REQ_ACC_SUCCESS,
	CORE_PRE_APPROVE_REQ_ACC_FAILURE,

	CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST,
	CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS,
	CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE,

	CORE_REJECT_REQ_ACC_REQUEST,
	CORE_REJECT_REQ_ACC_SUCCESS,
	CORE_REJECT_REQ_ACC_FAILURE,

	CORE_DELETE_REQ_ACC_REQUEST,
	CORE_DELETE_REQ_ACC_SUCCESS,
	CORE_DELETE_REQ_ACC_FAILURE,

	CORE_SUBMIT_REQ_ACC_REQUEST,
	CORE_SUBMIT_REQ_ACC_SUCCESS,
	CORE_SUBMIT_REQ_ACC_FAILURE,

	CORE_SHOP_SUBMIT_REQ_ACC_REQUEST,
	CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS,
	CORE_SHOP_SUBMIT_REQ_ACC_FAILURE,

	CORE_COMPLETE_REQ_ACC_REQUEST,
	CORE_COMPLETE_REQ_ACC_SUCCESS,
	CORE_COMPLETE_REQ_ACC_FAILURE,

	CORE_COMMENT_REQ_ACC_REQUEST,
	CORE_COMMENT_REQ_ACC_SUCCESS,
	CORE_COMMENT_REQ_ACC_FAILURE,

	CORE_ATTACH_FILE_REQ_ACC_REQUEST,
	CORE_ATTACH_FILE_REQ_ACC_SUCCESS,
	CORE_ATTACH_FILE_REQ_ACC_FAILURE,

	CORE_GENCODE_NPI_REQ_ACC_REQUEST,
	CORE_GENCODE_NPI_REQ_ACC_SUCCESS,
	CORE_GENCODE_NPI_REQ_ACC_FAILURE,

	CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST,
	CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS,
	CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE,

	CORE_SHOP_APPROVE_REQ_ACC_REQUEST,
	CORE_SHOP_APPROVE_REQ_ACC_SUCCESS,
	CORE_SHOP_APPROVE_REQ_ACC_FAILURE,

	CORE_CANCEL_REQ_ACC_REQUEST,
	CORE_CANCEL_REQ_ACC_SUCCESS,
	CORE_CANCEL_REQ_ACC_FAILURE,

	CORE_RE_STATUS_REQ_ACC_REQUEST,
	CORE_RE_STATUS_REQ_ACC_SUCCESS,
	CORE_RE_STATUS_REQ_ACC_FAILURE,

	CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST,
	CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS,
	CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE,




	CORE_GET_REPORT_DRAWING_STATUS_REQUEST,
	CORE_GET_REPORT_DRAWING_STATUS_SUCCESS,
	CORE_GET_REPORT_DRAWING_STATUS_FAILURE,
	CORE_GET_REPORT_VIEW_DRAWING_REQUEST,
	CORE_GET_REPORT_VIEW_DRAWING_SUCCESS,
	CORE_GET_REPORT_VIEW_DRAWING_FAILURE,

	CORE_RE_STATUS_SELL_ORDER_REQUEST,
	CORE_RE_STATUS_SELL_ORDER_SUCCESS,
	CORE_RE_STATUS_SELL_ORDER_FAILURE,

	// CORE_GET_DOWNLOAD_DRAWING_FILE_REQUEST,
	CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS,
	CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE,


	CORE_GET_REPORT_FOLLOW_STATUS_REQUEST,
	CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS,
	CORE_GET_REPORT_FOLLOW_STATUS_FAILURE,

	CORE_GET_REPORT_SUMMARY_STATUS_REQUEST,
	CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS,
	CORE_GET_REPORT_SUMMARY_STATUS_FAILURE,

	CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST,
	CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS,
	CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE,



} from '../types'

import {
	CORE_LOAD_MASTER_DATA_COATINGS_REQUEST,
	CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS,
	CORE_LOAD_MASTER_DATA_COATINGS_FAILURE,

	CORE_LOAD_MASTER_DATA_COATING_REQUEST,
	CORE_LOAD_MASTER_DATA_COATING_SUCCESS,
	CORE_LOAD_MASTER_DATA_COATING_FAILURE,

	CORE_LOAD_MASTER_DATA_COATING_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_COATING_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_COATING_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_MATERIALS_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE,

	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE,

	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE,

	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE,

	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_REQUEST,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE,

	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_REQUEST,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE,

	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE,

	CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST,
	CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS,
	CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE,

	CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE,

	CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_REQUEST,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE,

	CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_REQUEST,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE,

	CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_REQUEST,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS,
	CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE,

	// CORE_LOAD_MASTER_DATA_REQUEST,
	CORE_LOAD_MASTER_DATA_SUCCESS,
	CORE_LOAD_MASTER_DATA_FAILURE,
} from '../masterDataTypes'

import {
	CORE_LOAD_MANAGE_SYSTEMS_REQUEST,
	CORE_LOAD_MANAGE_SYSTEMS_SUCCESS,
	CORE_LOAD_MANAGE_SYSTEMS_FAILURE,

	CORE_LOAD_MANAGE_SYSTEM_REQUEST,
	CORE_LOAD_MANAGE_SYSTEM_SUCCESS,
	CORE_LOAD_MANAGE_SYSTEM_FAILURE,

	CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST,
	CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS,
	CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE,

	CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST,
	CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS,
	CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE,

	CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST,
	CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS,
	CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE,

	CORE_LOAD_MANAGE_GROUPS_REQUEST,
	CORE_LOAD_MANAGE_GROUPS_SUCCESS,
	CORE_LOAD_MANAGE_GROUPS_FAILURE,

	CORE_LOAD_MANAGE_GROUP_REQUEST,
	CORE_LOAD_MANAGE_GROUP_SUCCESS,
	CORE_LOAD_MANAGE_GROUP_FAILURE,

	CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST,
	CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS,
	CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE,

	CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST,
	CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS,
	CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE,

	CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST,
	CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS,
	CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE,
} from '../manageTypes'


const initialStateCallAPI = {
	isLoading: false,

	hasError: false,
	errorMessage: '',
	errorCode: '',
	statusText: ''
}
	, initialStateArray = []


export default {
	errorList: (state = initialStateArray, action) => {
		switch (action.type) {
			case SET_ERROR:
				let newError = []
				if (action && Array.isArray(action.error)) {
					newError = action.error
				}
				return newError

			case CORE_AUTH_VERIFY_SUCCESS:
			case CORE_LOAD_DRAWING_INFORMATION_SUCCESS:
			case CORE_LOAD_MASTER_DATA_SUCCESS:
			case CORE_LOAD_ITEM_INFORMATION_SUCCESS:
			case CORE_SAVE_ITEM_SUCCESS:
			case CORE_SUBMIT_ITEM_SUCCESS:
			case CORE_GEN_CODE_ITEM_SUCCESS:
			case CORE_APPROVE_ITEM_SUCCESS:
			case CORE_UPDATE_DRAWING_INFO_SUCCESS:
			case CORE_CREATE_DRAWING_INFO_SUCCESS:
			case CORE_GET_TUBE_INSIDE_DATA_SUCCESS:
			case CORE_GET_PIPE_TYPE_DATA_SUCCESS:
			case CORE_LOAD_CUSTOMER_SUCCESS:
			case CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS:
			case CORE_CREATE_SELL_ORDER_INFO_SUCCESS:
			case CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS:
			case CORE_UPDATE_SELL_ORDER_INFO_SUCCESS:
			case CORE_SEARCH_SELL_ORDER_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS:
			case CORE_LOAD_SETTING_SUCCESS:
			case CORE_CHANGE_SETTING_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS:
			case CORE_REJECT_SELL_ORDER_SUCCESS:
			case CORE_DELETE_SELL_ORDER_SUCCESS:
			case CORE_PRE_APPROVE_SUCCESS:
			case CORE_CUSTOMER_APPROVE_SUCCESS:
			case CORE_APPROVE_SUCCESS:
			case CORE_SUBMIT_SUCCESS:
			case CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS:
			case CORE_COMPLETE_SELL_ORDER_SUCCESS:
			case CORE_COMMENT_SELL_ORDER_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEMS_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS:
			case CORE_LOAD_MANAGE_GROUPS_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS:
			case CORE_CHANGE_USER_NPI_PERMIT_SUCCESS:
			case CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS:
			case CORE_CREATE_CUSTOMER_SUCCESS:
			case CORE_GENCODE_NPI_SELL_ORDER_SUCCESS:
			case CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS:
			case CORE_CANCEL_SELL_ORDER_SUCCESS:
			case CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS:
			case CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS:
			case CORE_CREATE_REQ_TUBE_INFO_SUCCESS:
			case CORE_UPDATE_REQ_TUBE_INFO_SUCCESS:
			case CORE_CREATE_REQ_ACC_INFO_SUCCESS:
			case CORE_UPDATE_REQ_ACC_INFO_SUCCESS:
			case CORE_RE_STATUS_SELL_ORDER_SUCCESS:
			case CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS:
			case CORE_ATTACH_FILE_SELL_ORDER_SUCCESS:
			case CORE_ATTACH_FILE_REQ_TUBE_SUCCESS:
			case CORE_ATTACH_FILE_REQ_ACC_SUCCESS:
			case CORE_RE_SEND_ITEM_SUCCESS:
			case CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { errors, result } = action.payload
					const { url } = action
					let newError = []
					if (!result) {
						if (Array.isArray(errors)) {
							errors.map(e => {
								const { path, code, message } = e
								return newError.push({ code, message, isShow: true, path, url, isFromAction: true })
							})
						}
						else newError.push({ code: "unknow", message: "Some thing went wrong", isShow: true, path: "", url, isFromAction: true })
					}

					return newError
				}
				return state

			case CORE_AUTH_VERIFY_FAILURE:
			case CORE_LOAD_DRAWING_INFORMATION_FAILURE:
			case CORE_LOAD_MASTER_DATA_FAILURE:
			case CORE_LOAD_ITEM_INFORMATION_FAILURE:
			case CORE_SAVE_ITEM_FAILURE:
			case CORE_SUBMIT_ITEM_FAILURE:
			case CORE_GEN_CODE_ITEM_FAILURE:
			case CORE_APPROVE_ITEM_FAILURE:
			case CORE_UPDATE_DRAWING_INFO_FAILURE:
			case CORE_CREATE_DRAWING_INFO_FAILURE:
			case CORE_GET_TUBE_INSIDE_DATA_FAILURE:
			case CORE_GET_PIPE_TYPE_DATA_FAILURE:
			case CORE_LOAD_CUSTOMER_FAILURE:
			case CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE:
			case CORE_CREATE_SELL_ORDER_INFO_FAILURE:
			case CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE:
			case CORE_UPDATE_SELL_ORDER_INFO_FAILURE:
			case CORE_SEARCH_SELL_ORDER_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATINGS_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE:
			case CORE_LOAD_SETTING_FAILURE:
			case CORE_CHANGE_SETTING_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE:
			case CORE_REJECT_SELL_ORDER_FAILURE:
			case CORE_DELETE_SELL_ORDER_FAILURE:
			case CORE_PRE_APPROVE_FAILURE:
			case CORE_CUSTOMER_APPROVE_FAILURE:
			case CORE_APPROVE_FAILURE:
			case CORE_SUBMIT_FAILURE:
			case CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE:
			case CORE_COMPLETE_SELL_ORDER_FAILURE:
			case CORE_COMMENT_SELL_ORDER_FAILURE:
			case CORE_ATTACH_FILE_SELL_ORDER_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEMS_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE:
			case CORE_LOAD_MANAGE_GROUPS_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE:
			case CORE_CHANGE_USER_NPI_PERMIT_FAILURE:
			case CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE:
			case CORE_CREATE_CUSTOMER_FAILURE:
			case CORE_GENCODE_NPI_SELL_ORDER_FAILURE:
			case CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE:
			case CORE_SHOP_APPROVE_SELL_ORDER_FAILURE:
			case CORE_CANCEL_SELL_ORDER_FAILURE:
			case CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE:
			case CORE_CREATE_REQ_TUBE_INFO_FAILURE:
			case CORE_UPDATE_REQ_TUBE_INFO_FAILURE:
			case CORE_CREATE_REQ_ACC_INFO_FAILURE:
			case CORE_UPDATE_REQ_ACC_INFO_FAILURE:
			case CORE_RE_STATUS_SELL_ORDER_FAILURE:
			case CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE:
			case CORE_RE_SEND_ITEM_FAILURE:
			case CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE:
				if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
					const { code, message, statusText, statusCode } = action.payload
					const { url } = action
					let newError = []

					newError.push({
						code: code ? code : "404",
						message,
						isShow: false,
						statusText,
						statusCode,
						url
					})

					return newError
				}
				return state
			default:
				return state
		}
	},
	isLoading: (state = false, action) => {
		switch (action.type) {
			case CORE_CREATE_DRAWING_REQUEST:
			// case CORE_SEARCH_DRAWING_REQUEST:
			case CORE_SAVE_ITEM_REQUEST:
			case CORE_SUBMIT_ITEM_REQUEST:
			case CORE_GEN_CODE_ITEM_REQUEST:
			case CORE_RE_SEND_ITEM_REQUEST:
			case CORE_APPROVE_ITEM_REQUEST:
			case CORE_UPDATE_DRAWING_INFO_REQUEST:
			case CORE_CREATE_DRAWING_INFO_REQUEST:
			case CORE_GET_TUBE_INSIDE_DATA_REQUEST:
			case CORE_GET_PIPE_TYPE_DATA_REQUEST:
			case CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST:
			case CORE_CREATE_SELL_ORDER_INFO_REQUEST:
			case CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST:
			case CORE_UPDATE_SELL_ORDER_INFO_REQUEST:
			case CORE_LOAD_MASTER_DATA_COATINGS_REQUEST:
			case CORE_LOAD_MASTER_DATA_COATING_REQUEST:
			case CORE_LOAD_MASTER_DATA_COATING_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_COATING_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_COATING_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIALS_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_REQUEST:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_REQUEST:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_REQUEST:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_REQUEST:
			case CORE_LOAD_SETTING_REQUEST:
			case CORE_CHANGE_SETTING_REQUEST:
			case CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_REQUEST:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_REQUEST:
			case CORE_REJECT_SELL_ORDER_REQUEST:
			case CORE_DELETE_SELL_ORDER_REQUEST:
			case CORE_PRE_APPROVE_REQUEST:
			case CORE_CUSTOMER_APPROVE_REQUEST:
			case CORE_APPROVE_REQUEST:
			case CORE_SUBMIT_REQUEST:
			case CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST:
			case CORE_COMPLETE_SELL_ORDER_REQUEST:
			case CORE_COMMENT_SELL_ORDER_REQUEST:
			case CORE_ATTACH_FILE_SELL_ORDER_REQUEST:
			case CORE_LOAD_MANAGE_SYSTEMS_REQUEST:
			case CORE_LOAD_MANAGE_SYSTEM_REQUEST:
			case CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST:
			case CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST:
			case CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST:
			case CORE_LOAD_MANAGE_GROUPS_REQUEST:
			case CORE_LOAD_MANAGE_GROUP_REQUEST:
			case CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST:
			case CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST:
			case CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST:
			case CORE_CHANGE_USER_NPI_PERMIT_REQUEST:
			case CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST:
			case CORE_CREATE_CUSTOMER_REQUEST:
			case CORE_GENCODE_NPI_SELL_ORDER_REQUEST:
			case CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST:
			case CORE_SHOP_APPROVE_SELL_ORDER_REQUEST:
			case CORE_CANCEL_SELL_ORDER_REQUEST:
			case CORE_LOAD_CUSTOMER_REQUEST:
			case CORE_SEARCH_SELL_ORDER_REQUEST:
			case CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST:
			case CORE_ATTACH_FILE_REQ_TUBE_REQUEST:
			case CORE_CREATE_REQ_TUBE_INFO_REQUEST:
			case CORE_UPDATE_REQ_TUBE_INFO_REQUEST:
			case CORE_SEARCH_REQ_ACC_REQUEST:
			case CORE_SEARCH_REQ_TUBE_REQUEST:
			case CORE_APPROVE_REQ_ACC_REQUEST:
			case CORE_PRE_APPROVE_REQ_ACC_REQUEST:
			case CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST:
			case CORE_REJECT_REQ_ACC_REQUEST:
			case CORE_DELETE_REQ_ACC_REQUEST:
			case CORE_SUBMIT_REQ_ACC_REQUEST:
			case CORE_SHOP_SUBMIT_REQ_ACC_REQUEST:
			case CORE_COMPLETE_REQ_ACC_REQUEST:
			case CORE_COMMENT_REQ_ACC_REQUEST:
			case CORE_ATTACH_FILE_REQ_ACC_REQUEST:
			case CORE_GENCODE_NPI_REQ_ACC_REQUEST:
			case CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST:
			case CORE_SHOP_APPROVE_REQ_ACC_REQUEST:
			case CORE_CANCEL_REQ_ACC_REQUEST:
			case CORE_RE_STATUS_REQ_ACC_REQUEST:
			case CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST:
			case CORE_APPROVE_REQ_TUBE_REQUEST:
			case CORE_PRE_APPROVE_REQ_TUBE_REQUEST:
			case CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST:
			case CORE_REJECT_REQ_TUBE_REQUEST:
			case CORE_DELETE_REQ_TUBE_REQUEST:
			case CORE_SUBMIT_REQ_TUBE_REQUEST:
			case CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST:
			case CORE_COMPLETE_REQ_TUBE_REQUEST:
			case CORE_COMMENT_REQ_TUBE_REQUEST:
			case CORE_GENCODE_NPI_REQ_TUBE_REQUEST:
			case CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST:
			case CORE_SHOP_APPROVE_REQ_TUBE_REQUEST:
			case CORE_CANCEL_REQ_TUBE_REQUEST:
			case CORE_RE_STATUS_REQ_TUBE_REQUEST:
			case CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST:
			case CORE_GET_REPORT_DRAWING_STATUS_REQUEST:
			case CORE_GET_REPORT_VIEW_DRAWING_REQUEST:
			case CORE_RE_STATUS_SELL_ORDER_REQUEST:
			case CORE_GET_REPORT_FOLLOW_STATUS_REQUEST:
			case CORE_GET_REPORT_SUMMARY_STATUS_REQUEST:
			case CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST:
				return true
			case CORE_CREATE_DRAWING_SUCCESS:
			// case CORE_SEARCH_DRAWING_SUCCESS:
			case CORE_SAVE_ITEM_SUCCESS:
			case CORE_SUBMIT_ITEM_SUCCESS:
			case CORE_GEN_CODE_ITEM_SUCCESS:
			case CORE_RE_SEND_ITEM_SUCCESS:
			case CORE_APPROVE_ITEM_SUCCESS:
			case CORE_UPDATE_DRAWING_INFO_SUCCESS:
			case CORE_CREATE_DRAWING_INFO_SUCCESS:
			case CORE_GET_TUBE_INSIDE_DATA_SUCCESS:
			case CORE_GET_PIPE_TYPE_DATA_SUCCESS:
			case CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS:
			case CORE_CREATE_SELL_ORDER_INFO_SUCCESS:
			case CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS:
			case CORE_UPDATE_SELL_ORDER_INFO_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS:
			case CORE_LOAD_SETTING_SUCCESS:
			case CORE_CHANGE_SETTING_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS:
			case CORE_REJECT_SELL_ORDER_SUCCESS:
			case CORE_DELETE_SELL_ORDER_SUCCESS:
			case CORE_PRE_APPROVE_SUCCESS:
			case CORE_CUSTOMER_APPROVE_SUCCESS:
			case CORE_APPROVE_SUCCESS:
			case CORE_SUBMIT_SUCCESS:
			case CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS:
			case CORE_COMPLETE_SELL_ORDER_SUCCESS:
			case CORE_COMMENT_SELL_ORDER_SUCCESS:
			case CORE_ATTACH_FILE_SELL_ORDER_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEMS_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS:
			case CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS:
			case CORE_LOAD_MANAGE_GROUPS_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS:
			case CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS:
			case CORE_CHANGE_USER_NPI_PERMIT_SUCCESS:
			case CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS:
			case CORE_CREATE_CUSTOMER_SUCCESS:
			case CORE_GENCODE_NPI_SELL_ORDER_SUCCESS:
			case CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS:
			case CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS:
			case CORE_CANCEL_SELL_ORDER_SUCCESS:
			case CORE_LOAD_CUSTOMER_SUCCESS:
			case CORE_SEARCH_SELL_ORDER_SUCCESS:
			case CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS:
			case CORE_ATTACH_FILE_REQ_TUBE_SUCCESS:
			case CORE_CREATE_REQ_TUBE_INFO_SUCCESS:
			case CORE_UPDATE_REQ_TUBE_INFO_SUCCESS:
			case CORE_SEARCH_REQ_ACC_SUCCESS:
			case CORE_SEARCH_REQ_TUBE_SUCCESS:
			case CORE_APPROVE_REQ_ACC_SUCCESS:
			case CORE_PRE_APPROVE_REQ_ACC_SUCCESS:
			case CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS:
			case CORE_REJECT_REQ_ACC_SUCCESS:
			case CORE_DELETE_REQ_ACC_SUCCESS:
			case CORE_SUBMIT_REQ_ACC_SUCCESS:
			case CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS:
			case CORE_COMPLETE_REQ_ACC_SUCCESS:
			case CORE_COMMENT_REQ_ACC_SUCCESS:
			case CORE_ATTACH_FILE_REQ_ACC_SUCCESS:
			case CORE_GENCODE_NPI_REQ_ACC_SUCCESS:
			case CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS:
			case CORE_SHOP_APPROVE_REQ_ACC_SUCCESS:
			case CORE_CANCEL_REQ_ACC_SUCCESS:
			case CORE_RE_STATUS_REQ_ACC_SUCCESS:
			case CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS:
			case CORE_APPROVE_REQ_TUBE_SUCCESS:
			case CORE_PRE_APPROVE_REQ_TUBE_SUCCESS:
			case CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS:
			case CORE_REJECT_REQ_TUBE_SUCCESS:
			case CORE_DELETE_REQ_TUBE_SUCCESS:
			case CORE_SUBMIT_REQ_TUBE_SUCCESS:
			case CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS:
			case CORE_COMPLETE_REQ_TUBE_SUCCESS:
			case CORE_COMMENT_REQ_TUBE_SUCCESS:
			case CORE_GENCODE_NPI_REQ_TUBE_SUCCESS:
			case CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS:
			case CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS:
			case CORE_CANCEL_REQ_TUBE_SUCCESS:
			case CORE_RE_STATUS_REQ_TUBE_SUCCESS:
			case CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS:
			case CORE_GET_REPORT_DRAWING_STATUS_SUCCESS:
			case CORE_GET_REPORT_VIEW_DRAWING_SUCCESS:
			case CORE_RE_STATUS_SELL_ORDER_SUCCESS:
			case CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS:
			case CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS:
			case CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS:
				return false
			case CORE_CREATE_DRAWING_FAILURE:
			// case CORE_SEARCH_DRAWING_FAILURE:
			case CORE_SAVE_ITEM_FAILURE:
			case CORE_SUBMIT_ITEM_FAILURE:
			case CORE_GEN_CODE_ITEM_FAILURE:
			case CORE_RE_SEND_ITEM_FAILURE:
			case CORE_APPROVE_ITEM_FAILURE:
			case CORE_UPDATE_DRAWING_INFO_FAILURE:
			case CORE_CREATE_DRAWING_INFO_FAILURE:
			case CORE_GET_TUBE_INSIDE_DATA_FAILURE:
			case CORE_GET_PIPE_TYPE_DATA_FAILURE:
			case CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE:
			case CORE_CREATE_SELL_ORDER_INFO_FAILURE:
			case CORE_UPDATE_SELL_ORDER_INFO_FAILURE:
			case CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATINGS_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE:
			case CORE_LOAD_SETTING_FAILURE:
			case CORE_CHANGE_SETTING_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE:
			case CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE:
			case CORE_REJECT_SELL_ORDER_FAILURE:
			case CORE_DELETE_SELL_ORDER_FAILURE:
			case CORE_PRE_APPROVE_FAILURE:
			case CORE_CUSTOMER_APPROVE_FAILURE:
			case CORE_APPROVE_FAILURE:
			case CORE_SUBMIT_FAILURE:
			case CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE:
			case CORE_COMPLETE_SELL_ORDER_FAILURE:
			case CORE_COMMENT_SELL_ORDER_FAILURE:
			case CORE_ATTACH_FILE_SELL_ORDER_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEMS_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE:
			case CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE:
			case CORE_LOAD_MANAGE_GROUPS_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE:
			case CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE:
			case CORE_CHANGE_USER_NPI_PERMIT_FAILURE:
			case CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE:
			case CORE_CREATE_CUSTOMER_FAILURE:
			case CORE_GENCODE_NPI_SELL_ORDER_FAILURE:
			case CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE:
			case CORE_SHOP_APPROVE_SELL_ORDER_FAILURE:
			case CORE_CANCEL_SELL_ORDER_FAILURE:
			case CORE_LOAD_CUSTOMER_FAILURE:
			case CORE_SEARCH_SELL_ORDER_FAILURE:
			case CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE:
			case CORE_ATTACH_FILE_REQ_TUBE_FAILURE:
			case CORE_CREATE_REQ_TUBE_INFO_FAILURE:
			case CORE_UPDATE_REQ_TUBE_INFO_FAILURE:
			case CORE_SEARCH_REQ_ACC_FAILURE:
			case CORE_SEARCH_REQ_TUBE_FAILURE:
			case CORE_APPROVE_REQ_ACC_FAILURE:
			case CORE_PRE_APPROVE_REQ_ACC_FAILURE:
			case CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE:
			case CORE_REJECT_REQ_ACC_FAILURE:
			case CORE_DELETE_REQ_ACC_FAILURE:
			case CORE_SUBMIT_REQ_ACC_FAILURE:
			case CORE_SHOP_SUBMIT_REQ_ACC_FAILURE:
			case CORE_COMPLETE_REQ_ACC_FAILURE:
			case CORE_COMMENT_REQ_ACC_FAILURE:
			case CORE_ATTACH_FILE_REQ_ACC_FAILURE:
			case CORE_GENCODE_NPI_REQ_ACC_FAILURE:
			case CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE:
			case CORE_SHOP_APPROVE_REQ_ACC_FAILURE:
			case CORE_CANCEL_REQ_ACC_FAILURE:
			case CORE_RE_STATUS_REQ_ACC_FAILURE:
			case CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE:
			case CORE_APPROVE_REQ_TUBE_FAILURE:
			case CORE_PRE_APPROVE_REQ_TUBE_FAILURE:
			case CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE:
			case CORE_REJECT_REQ_TUBE_FAILURE:
			case CORE_DELETE_REQ_TUBE_FAILURE:
			case CORE_SUBMIT_REQ_TUBE_FAILURE:
			case CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE:
			case CORE_COMPLETE_REQ_TUBE_FAILURE:
			case CORE_COMMENT_REQ_TUBE_FAILURE:
			case CORE_GENCODE_NPI_REQ_TUBE_FAILURE:
			case CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE:
			case CORE_SHOP_APPROVE_REQ_TUBE_FAILURE:
			case CORE_CANCEL_REQ_TUBE_FAILURE:
			case CORE_RE_STATUS_REQ_TUBE_FAILURE:
			case CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE:
			case CORE_GET_REPORT_DRAWING_STATUS_FAILURE:
			case CORE_GET_REPORT_VIEW_DRAWING_FAILURE:
			case CORE_RE_STATUS_SELL_ORDER_FAILURE:
			case CORE_GET_REPORT_FOLLOW_STATUS_FAILURE:
			case CORE_GET_REPORT_SUMMARY_STATUS_FAILURE:
			case CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE:
				return false

			default:
				return state
		}

	},
	reducerCallAPI: (state = initialStateCallAPI, action) => {
		switch (action.type) {

			default:
				return state
		}
	},

}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js